// Personal libs
import { TokenTypeEnum } from '@shared/enum/token-type.enum';
import {
  extractTimeDataFromSeconds,
  getSecondsUntilBackendDate,
} from '@shared/lib/date.lib';
import { SessionToken } from './session-token.abstract';
import {
  dbGetActiveUser,
  dbResetRefreshToken,
} from '@data/datasource/local/user.database';
import { TokenStatusEnum } from '@shared/enum/token-status.enum';
import { IUser } from '@shared/interface/model.interface';

export class RefreshToken extends SessionToken {
  /**
   * Constructor
   */
  public constructor() {
    super(TokenTypeEnum.REFRESH_TOKEN);
  }

  /**
   * Private properties
   */
  private confirmationMessageThreshold = 120; // 2*60
  // private confirmationMessageThreshold = 20; // 2*60

  /**
   * Overriden methods
   */
  async refreshTokenData(user?: IUser) {
    const activeUser = user ?? await dbGetActiveUser();

    this.remainingTime.value = getSecondsUntilBackendDate(
      activeUser?.refreshToken?.valid,
    );
    this.ttl = activeUser?.refreshToken?.ttl;
    this.retries = activeUser?.refreshToken?.retries;
    this.fingerprint = activeUser?.refreshToken?.fingerprint;

    if (this.remainingTime.value < 0) {
      this.remainingTime.value = 0;
    }
    this.remainingDataTime.value = extractTimeDataFromSeconds(
      this.remainingTime.value,
    );
  }

  async refreshStatus(): Promise<void> {
    if (this.remainingTime.value == null || this.remainingTime.value == 0) {
      this.tokenStatus.value = TokenStatusEnum.INACTIVE;
    } else if (
      this.remainingTime.value >= 0 &&
      this.remainingTime.value < this.confirmationMessageThreshold
    ) {
      // the user has 3 minutes to reconnect if needed
      // 180 sec. + 30 sec of crontask interval
      this.tokenStatus.value = TokenStatusEnum.END_OF_LIVE;
    } else if (this.remainingTime.value >= this.confirmationMessageThreshold) {
      this.tokenStatus.value = TokenStatusEnum.ACTIVE;
    }
  }

  async refresh() {
    // Nothing to do here
  }

  async clearToken(): Promise<void> {
    this.remainingDataTime.value = undefined;
    this.remainingTime.value = undefined;
    this.tokenStatus.value = TokenStatusEnum.INACTIVE;
    // TODO : call api to reset refreshToken
    await dbResetRefreshToken();
  }
}
